(function() {
	'use strict';

	document.querySelector('.js-MobileNav-toggle').addEventListener('click', function(event) {
		document.body.classList.toggle('MobileNav--isOpen');
		event.stopPropagation();
	});

	document.querySelector('.js-MobileNav-content').addEventListener('click', function(event) {
		document.body.classList.remove('MobileNav--isOpen');
	});

}());
